import React, { useState } from 'react';
import './App.css';
import Menu from './components/Menu';
import { Container, Row, Col, Navbar, NavbarToggler, NavbarBrand } from 'reactstrap';

function Academias() {

    const [menu, setMenu] = useState(false);
    const toggleMenu = () => { setMenu(!menu); };

    return (
        <div id="wrapper" className={`d-flex ${menu ? 'toggled' : ''}`}>
            <Menu />
            <div id="page-content-wrapper">
                <Navbar className="bg-azul" dark>
                    <NavbarToggler onClick={toggleMenu} className="mr-2 border-0" />
                    <NavbarBrand className='mr-auto'>Academias</NavbarBrand>
                </Navbar>
                <Container>
                    <Row>
                        <Col className="mt-3">
                            <iframe 
                                src="https://app.kravmaga.org.br/adm/mapa" 
                                style={{ 'width': '100%', 'height': '88vh', 'border': 'none'}} 
                            ></iframe>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default Academias;
